import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_14119_11043)",
		children: /* @__PURE__ */ _jsx("path", { d: "M10.1865 6.01831C9.45647 6.01831 8.32647 5.18831 7.13647 5.21831C5.56647 5.23831 4.12647 6.12831 3.31647 7.53831C1.68647 10.3683 2.89647 14.5483 4.48647 16.8483C5.26647 17.9683 6.18647 19.2283 7.40647 19.1883C8.57647 19.1383 9.01647 18.4283 10.4365 18.4283C11.8465 18.4283 12.2465 19.1883 13.4865 19.1583C14.7465 19.1383 15.5465 18.0183 16.3165 16.8883C17.2065 15.5883 17.5765 14.3283 17.5965 14.2583C17.5665 14.2483 15.1465 13.3183 15.1165 10.5183C15.0965 8.17831 17.0265 7.05831 17.1165 7.00831C16.0165 5.39831 14.3265 5.21831 13.7365 5.17831C12.1965 5.05831 10.9065 6.01831 10.1865 6.01831ZM12.7865 3.65831C13.4365 2.87831 13.8665 1.78831 13.7465 0.708313C12.8165 0.748313 11.6965 1.32831 11.0265 2.10831C10.4265 2.79831 9.90647 3.90831 10.0465 4.96831C11.0765 5.04831 12.1365 4.43831 12.7865 3.65831Z" })
	})
});
export default SvgAppleFill;
